export default __webpack_public_path__ + "static/media/R3No4.627a2cf6.mp3";